import * as React from "react";
import Modal from "react-bootstrap/Modal";
import { ProtectiveFunctionLocation } from "../models/protectiveFunctionLocation";
import { PSF_ProtectiveFunctionComments } from "../models/PSF_ProtectiveFunctionComments";
import { ccfByLocation, updateCcfByLocation, votingConfigByLocation, updateVotingConfigByLocation } from "../psfHelpers";
import { isMooNVotingType, parseMooNVoting, formatMooNVoting, IMooN } from "../helpers";
import Draggable from "react-draggable";

interface Props {
  psfProtectiveFunctionComments: PSF_ProtectiveFunctionComments;
  location: ProtectiveFunctionLocation;
  onCloseModal: () => void;
  onSubmit: (updatedPsf: PSF_ProtectiveFunctionComments) => Promise<void>;
  zoom: number;
}

interface State {
  closeFocus: boolean;
  isAllowSubmit: boolean;
  votingMooNValue: IMooN;
  ccf?: number;
  formValidationFields: {
    votingMooNValueM: boolean;
    votingMooNValueN: boolean;
    ccf: boolean;
  },
}

export class MooNInputConfigModal extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      closeFocus: false,
      isAllowSubmit: true,
      votingMooNValue: {
        M: 1,
        N: 1
      },
      formValidationFields: {
        votingMooNValueM: true,
        votingMooNValueN: false,
        ccf: true
      }
    };
  }

  configureDeviceVoting = () => {
    const voting = votingConfigByLocation(this.props.location, this.props.psfProtectiveFunctionComments);
    const ccf = ccfByLocation(this.props.location, this.props.psfProtectiveFunctionComments);
    if (isMooNVotingType(voting)) {
      this.setState({
        votingMooNValue: parseMooNVoting(voting),
        ccf: ccf,
      }, this.validateForm);
    }
  }

  handleMOrNChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    var inputValue = e.target.value;
    if (/[^0-9]+/.test(inputValue)) { // prevents input anything except numbers from 1 to 9
      inputValue = inputValue.replace(/[^0-9]*/g, "");
    }
    const val = parseFloat(inputValue);
    var moon = { ... this.state.votingMooNValue };
    moon[e.target.name] = val;
    this.setState({ votingMooNValue: moon }, this.validateForm)
  }

  handleCcfChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newCcf = parseFloat(e.target.value);
    if (newCcf >= 0) {
      this.setState({ ccf: newCcf }, this.validateForm);
    }
  }

  validateForm = () => {
    var isAllowSubmit = true;
    var votingMooNValue = this.state.votingMooNValue;
    var formValidationFields = this.state.formValidationFields;

    if (votingMooNValue.M == 0 || votingMooNValue.N == 0) {
      if (votingMooNValue.M == 0) {
        isAllowSubmit = false;
        formValidationFields.votingMooNValueM = false;
      } else {
        formValidationFields.votingMooNValueM = true;
      }
      if (votingMooNValue.N == 0) {
        isAllowSubmit = false;
        formValidationFields.votingMooNValueN = false;
      } else {
        formValidationFields.votingMooNValueN = true;
      }
    } else {
      if (votingMooNValue.M > votingMooNValue.N) {
        isAllowSubmit = false;
        formValidationFields.votingMooNValueM = false;
      } else {
        formValidationFields.votingMooNValueM = true;
        formValidationFields.votingMooNValueN = true;
      }
    }

    if (votingMooNValue.M !== votingMooNValue.N && this.state.ccf == null) {
      isAllowSubmit = false;
      formValidationFields.ccf = true;
    }

    this.setState({
      isAllowSubmit: isAllowSubmit,
      formValidationFields: formValidationFields
    });
  }

  componentDidMount() {
    this.configureDeviceVoting();
  }

  modalTitle = () => {
    const locationString = this.props.location.toString();
    const isInputConfig = locationString.startsWith("INP");
    const configNumber = locationString.charAt(locationString.length - 1);
    return isInputConfig
      ? `MooN Specification Input ${configNumber}`
      : `MooN Specification Action ${configNumber}`;
  };

  handleUpdateButtonClicked = () => {
    const ccf = this.state.votingMooNValue.M === this.state.votingMooNValue.N
      ? null
      : this.state.ccf;
    let updatedPsf = updateCcfByLocation(
      ccf,
      this.props.location,
      this.props.psfProtectiveFunctionComments
    );
    updatedPsf = updateVotingConfigByLocation(
      formatMooNVoting(this.state.votingMooNValue, true),
      this.props.location,
      updatedPsf
    );
    this.props.onSubmit(updatedPsf).then(() => this.props.onCloseModal());
  };

  onMouseEnter = () => {
    this.setState({
      closeFocus: true
    });
  };

  onMouseLeave = () => {
    this.setState({
      closeFocus: false
    });
  };

  render() {
    const zoom = this.props.zoom;

    var closeClass = this.state.closeFocus
      ? "ui-dialog-titlebar-close ui-corner-all ui-state-hover"
      : "ui-dialog-titlebar-close ui-corner-all";

    return (
      <Modal
        show={true}
        animation={false}
        centered={true}
        onEscapeKeyDown={this.props.onCloseModal}
        onHide={() => {
          /* don't allow hide via off-click*/
        }}
        size="lg"
        enforceFocus={true}
        style={{
          zIndex: 10001, background: "rgba(000, 000, 000, 0.5)"
        }}
      >
        <Draggable
          axis="both"
          handle=".ui-dialog-titlebar"
        >
          <div
            id="MooNConfigModal"
            className="ui-dialog ui-widget ui-widget-content ui-corner-all ui-draggable"
            tabIndex={-1}
            role="dialog"
            aria-labelledby="ui-dialog-title-ccfaction3"
            style={{
              display: "block",
              zIndex: 10001,
              outline: "0px",
              height: "auto",
              width: "350px",
              left: `${zoom * 375}px`,
              top: `${zoom * 750}px`
            }}
          >
            <div className="ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix">
              <span className="ui-dialog-title" id="ui-dialog-title-ccfaction3">
                {this.modalTitle()}
              </span>
              <div className={closeClass}>
                <span
                  className="ui-icon ui-icon-closethick"
                  style={{ cursor: "pointer" }}
                  onMouseEnter={this.onMouseEnter}
                  onMouseLeave={this.onMouseLeave}
                  onClick={this.props.onCloseModal}
                >
                  close
              </span>
              </div>
            </div>
            <div
              id="ccfaction3"
              className="ui-dialog-content ui-widget-content"
              style={{
                display: "block",
                width: "auto",
                minHeight: "0px",
                height: "200px"
              }}
            >

              <div>
                <span>User Specified M</span>
                <br />
                <input
                  name="M"
                  type="number"
                  min="1"
                  step="1"
                  value={this.state.votingMooNValue.M}
                  id="UserConfigurationM"
                  className={`${!this.state.formValidationFields.votingMooNValueM ? "input-error-state" : ""}`}
                  onChange={(e) => this.handleMOrNChange(e)}
                />
              </div>
              <div>
                <span>User Specified N</span>
                <br />
                <input
                  name="N"
                  type="number"
                  min="1"
                  step="1"
                  value={this.state.votingMooNValue.N}
                  id="UserConfigurationN"
                  className={`${!this.state.formValidationFields.votingMooNValueN ? "input-error-state" : ""}`}
                  onChange={(e) => this.handleMOrNChange(e)}
                />
              </div>
              <div>
                <span id="UserCCFAction3">User Specified CCF(%)</span>
                <span
                  className="sil-tooltip"
                  title="When explicitly modeling redundant architectures (e.g., 1oo2, 2oo3, 1oo3) in the GUI, this field is used to enter an appropriate amount of common cause to apply between the redundant channels.  Be aware that any device boxes entered within a channel may automatically have some common cause applied, depending on the voting architecture selected when configuring that device  and the parameters of the datasheet for that device."
                >
                  ?
                </span>
                <br />
                {this.state.votingMooNValue.M === this.state.votingMooNValue.N
                  ? <span style={{color: "grey"}}>N/A</span>
                  : <input
                    name="uservalue_CCFdiva3"
                    type="number"
                    value={this.state.ccf ?? ""}
                    id="uservalue_CCFdiva3"
                    className={`${!this.state.formValidationFields.ccf ? "input-error-state" : ""}`}
                    onChange={(e) => this.handleCcfChange(e)}
                    />
                  }
                <div className="update-button-div" style={{ marginTop: "3px" }}>
                  <input
                    type="submit"
                    name="CCFButtona3"
                    value="Update"
                    id="CCFButtona3"
                    className={`green-button edit-button ${!this.state.isAllowSubmit ? 'disabled' : ""}`}
                    onClick={this.handleUpdateButtonClicked}
                    disabled={!this.state.isAllowSubmit}
                  />
                </div>
              </div>
            </div>
          </div>
        </Draggable>
      </Modal>
    );
  }
}
